import axiosInstance from "../axiosInstance";

export const sendNotificationToClient = async (notification) => {
  const response = await axiosInstance.post(
    "/candidate/send-to-client",
    notification,
  );

  return response.data;
};
